/**
 * FormNumbers
 * ------------------------------------------------------------------------------
 * This field decorates input number fields with a plus and minus button.
 * Might be able to handle this with CSS
 *
 * @namespace custom
 */
custom.FormNumbers = (() => {
  // Cache
  var $this;
  var $btns;

  const targetClass = 'js-form-numbers';
  const initializedClass = 'js-form-numbers-initialized';

  function getMaximum($form) {
    var $input = $form.find('input[type="number"]');
    const inputMax =
      $input.attr('max') !== undefined &&
      $input.attr('max') !== null &&
      $input.attr('max') !== ''
        ? parseInt($input.attr('max'))
        : null;
    return inputMax;
  }

  function getMinimum($form) {
    var $input = $form.find('input[type="number"]');
    const inputMin = parseInt($input.attr('min'));
    return inputMin ? inputMin : 0;
  }

  function DisplayNumber($form) {
    var $display = $form.find('.input-number__display');
    $display.html(getCurrentValue($form));
  }

  function getCurrentValue($form) {
    var $input = $form.find('input[type="number"]');
    return parseInt($input.val());
  }

  function setNewValue($form, number) {
    var $input = $form.find('input[type="number"]');
    $input.prop('value', number);
    $input.trigger('input');
    DisplayNumber($form);
  }

  function numberHandler(event) {
    var $clickedBtn = $(event.currentTarget);
    var $targetForm = $clickedBtn.closest(`.${targetClass}`);
    var curVal = getCurrentValue($targetForm);
    if ($clickedBtn.hasClass('disabled')) return;
    // Limitation
    var max = getMaximum($targetForm);
    var min = getMinimum($targetForm);

    // is this the inventory panel
    $isInventoryPanel = $clickedBtn
      .closest('form')
      .hasClass('js-add-multiple-to-cart-form');

    if ($clickedBtn.hasClass('plus')) {
      if (max === null || (max > 0 && max > curVal)) {
        setNewValue($targetForm, curVal + 1);
        calculatePrice(event);
      }
    } else {
      if (min < curVal) {
        setNewValue($targetForm, curVal - 1);
        calculatePrice(event);
      }
    }
  }

  function calculatePrice(e) {
    const $form = $(e.currentTarget).closest('form');
    const formValuesArray = $form.serializeArray();
    const formValuesWithQuantity = formValuesArray.filter(
      ({ name, value }) => value > 0 && name !== 'handle',
    );
    //if no qty selected just return
    if (formValuesWithQuantity.length === 0) {
      return false;
    }
    let subtotal = 0;
    formValuesWithQuantity.forEach(({ name, value }) => {
      let price = $form
        .find(`input[name="${name}"]`)
        .closest('tr')
        .find('.js-table-variant-identifier')
        .text();
      subtotal +=
        parseFloat(price.replace('$', '').split(',').join('')) * Number(value);
    });
    let formattedprice = slate.Currency.formatMoney(
      subtotal.toFixed(2),
      '${{ amount_no_decimals }}',
    );
    addToCartPrice(formattedprice, $form);
  }

  function addToCartPrice(price, $form) {
    $form
      .find('button[type="submit"][data-label="Add to Cart"]')
      .html(
        `<div class="flex spacer-0--gap-x justify-center">Add to cart <span class="content-disabled">|</span> ${price}</span>`,
      );
  }

  function init() {
    $this = $(`.${targetClass}:not(.${initializedClass})`);
    $btns = $this.find('.input-number__button');

    // Display initial number
    $.each($this, function () {
      DisplayNumber($(this));
      $(this).addClass(initializedClass);
    });

    // Event
    $btns.on('click', numberHandler);
  }

  return {
    init: init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/form-numbers.js